/*
  The set band: tick what you want, watch the total, add it in one request.

  Until 2026-09-22 this was one button that added a fixed list. The comp turns the rail
  into a set the shopper assembles, so the arithmetic moved here: the panel counts what is
  ticked, totals it, and the button posts only those lines.

  Three things worth knowing:

  Nothing starts ticked but the product itself, which is ticked and disabled. The comp
  draws two of three cards pre-ticked and a total that includes a pole nobody asked for.
  Pre-ticking a paid add-on is the pattern that gets stores fined, and it makes the number
  on the panel one the shopper did not choose.

  The total is formatted through the shop's own money format rather than with a hardcoded
  dollar sign, because the theme should not be the thing that decides what currency this
  store is in. Both of Shopify's placeholders are handled; anything else falls back to the
  number with its separators, which is wrong-looking rather than wrong.

  One /cart/add.js with every line, not a loop of single adds. A loop on this store
  reliably trips the rate limiter, and the 429 comes back looking like the product being
  unavailable.
*/
(() => {
  const withSeparators = (n) =>
    n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const money = (cents, format) => {
    const whole = Math.round(cents / 100);
    const withDecimals = (cents / 100).toFixed(2);
    const [dollars, pennies] = withDecimals.split('.');
    if (!format) return `$${withSeparators(dollars)}.${pennies}`;
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withSeparators(whole))
      .replace(/\{\{\s*amount\s*\}\}/g, `${withSeparators(dollars)}.${pennies}`);
  };

  document.querySelectorAll('[data-atlas-complements]').forEach((root) => {
    const btn = root.querySelector('[data-atlas-comp-add]');
    const status = root.querySelector('[data-atlas-comp-status]');
    const totalEl = root.querySelector('[data-atlas-set-total]');
    const countEl = root.querySelector('[data-atlas-set-count]');
    const boxes = [...root.querySelectorAll('[data-atlas-set-item]')];
    if (!btn) return;

    const format = root.dataset.moneyFormat || '';
    const basePrice = Number(root.dataset.basePrice || 0);
    const baseId = root.dataset.baseId;

    const chosen = () => boxes.filter((b) => b.checked);

    const refresh = () => {
      const picked = chosen();
      const total = picked.reduce((sum, b) => sum + Number(b.dataset.price || 0), basePrice);
      const count = picked.length + 1;
      if (totalEl) totalEl.textContent = money(total, format);
      if (countEl) countEl.textContent = `${count} item${count === 1 ? '' : 's'} selected`;
    };

    boxes.forEach((b) => b.addEventListener('change', refresh));
    refresh();

    btn.addEventListener('click', async () => {
      const ids = [baseId, ...chosen().map((b) => b.value)].filter(Boolean);
      if (!ids.length) return;

      btn.setAttribute('disabled', 'disabled');
      status.textContent = 'Adding…';
      status.className = 'atlas-setband__status';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'The cart rejected the request.');
        }
        status.textContent = `Added ${ids.length} item${ids.length === 1 ? '' : 's'} to your cart.`;
        status.className = 'atlas-setband__status is-ok';
        document.dispatchEvent(new CustomEvent('atlas:cart:updated'));
        window.location.href = '/cart';
      } catch (e) {
        status.textContent = e.message;
        status.className = 'atlas-setband__status is-error';
      } finally {
        btn.removeAttribute('disabled');
      }
    });
  });
})();
